export const kioskTransactionsResource = {
  name: '付款亭交易',
  fields: {
    createdAt: '付款時間',
    receiptReference: '收據參考編號',
    visitStatus: '充電狀態',
    siteName: '場地',
    kioskName: '付款亭',
    bayNumber: '車位',
    method: '付款方式',
    status: '付款狀態',
    depositAmount: '按金',
    finalCharge: '收費',
    refundAmount: '退款',
    refundState: '退款狀態',
    refundDueAt: '退款開始時間',
    refundExpiresAt: '可於付款亭領取至',
    refundedAt: '退回卡內時間',
    csRefundedAt: '人手退款時間',
    csRefundNotes: '客戶服務備註',
    paidWith: '付款工具',
    providerRef: 'SoePay 參考編號',
    settleState: '結算',
    settleType: 'SoePay 指令',
    instructionStatus: '指令狀態',
    instructionAmount: '金額',
    instructionAttempts: '發送次數',
    sentCall: '最後發送的指令',
    failureReason: '原因',
    checks: '向 SoePay 查核次數',
    lastCheck: '最後查核結果',
    lastCheckedAt: '最後查核時間',
    nextCheckAt: '下次自動查核',
    doubleRefund: 'Refunded twice',
    lastError: 'SoePay 最後回覆',
  },
  filters: {
    receiptReference: '收據參考編號',
    octopusCardId: '八達通號碼',
    octopusCardIdHelper: '卡上的號碼，不包括括號內的數字',
    octopusCardIdInvalid: '八達通號碼格式不正確',
    siteId: '場地',
    method: '付款方式',
    refundState: '退款狀態',
    from: '由',
    to: '至',
  },
  methods: { octopus: '八達通', card: '信用卡', qr: 'QR 付款', free: '免費（測試）' },
  detailsMissing: '缺少詳情',
  unknownValue: '未知',
  sessionLink: 'Kiosk transaction',
  wallets: { alipay_hk: 'Alipay HK', wechat_pay: 'WeChat Pay' },
  refundStates: {
    none: '無退款',
    open: '待領取',
    paid: '已退款',
    expired_no_attempt: '已過期：未嘗試',
    expired_attempt_failed: '已過期：嘗試失敗',
    expired_result_unknown: '已過期：結果不明',
    expired_reader_replaced: '已過期：讀卡器已更換',
    paid_after_expiry: '過期後已退款',
    refunded_by_hand: '已人手退款',
    released: '已解除',
    captured: '已收費',
    refund_pending: '退款處理中',
    refunded: '已退款',
    unknown: 'SoePay 回覆不明',
    failed: '交由客戶服務處理',
  },
  settleStates: {
    none: '沒有 SoePay 指令',
    pending: '發送中',
    unknown: '回覆不明',
    done: '已完成',
    failed: '交由客戶服務處理',
  },
  settleTypes: {
    card_capture: '從卡收費',
    card_void: '解除卡上預授權',
    card_refund: '退款至卡',
    qr_refund: '退款至 QR 付款應用程式',
    qr_cancel: '取消 QR 付款',
  },
  instructionStatuses: { pending: '等候中', in_progress: '處理中', completed: '已完成', failed: '失敗', cancelled: '已取消', expired: '已過期' },
  sentCalls: { capture: '收費', cancel: '取消', refund: '退款' },
  lastChecks: { done: '已完成', not_done: '未完成', unclear: '未能確定', conflict: '與我們的紀錄不符' },
  failureReasons: {
    maav_exceeded: '卡內未能容納此金額',
    card_not_accepted: '不接受此卡',
    reader_error: '讀卡器錯誤',
    unknown_outcome: '結果不明',
    provider_refused: 'SoePay 拒絕了指令',
    provider_unclear: 'SoePay 於 24 小時內未有確認',
    conflict: 'SoePay 的紀錄與我們的不符',
  },
  sections: { visit: '充電', amounts: '金額', refund: '退款', costBreakdown: '費用明細', attempts: '退款嘗試', soepay: 'SoePay', soepayAttempts: 'SoePay 指令紀錄' },
  lines: {
    energy: '%{kwh} kWh，每度 HK$%{rate}%{window}',
    sessionFee: '每次充電費',
    timeFee: '時間費',
    idleFee: '佔用費',
    depositCap: '以按金為上限',
    total: '總收費',
  },
  attempts: { at: '時間', change: '變更', reason: '讀卡器原因', reasonSoepay: '原因', count: '嘗試次數', detail: '詳情' },
  markByHand: {
    button: '標記為已人手退款',
    title: '標記為已人手退款',
    body: '記錄客戶服務已於付款亭以外退回收據 %{reference} 的 HK$%{amount}。付款亭其後仍可能把款項退回卡內；如有此情況，您會收到電郵。',
    note: '備註',
    noteHelper: '退款方式及日期，例如「FPS 2026-09-30，來電編號 4471」',
    confirm: '標記為已退款',
    done: '已標記為人手退款',
    failed: '未能標記為人手退款',
    bodySoepay: '記錄客戶服務已於 SoePay 以外（例如以 FPS）退回收據 %{reference} 的 HK$%{amount}。此後不會再要求 SoePay 退款。如 SoePay 仍完成此付款的退款，您會收到電郵，請查核客戶只獲退款一次。',
  },
  markRefusals: {
    paid: '此退款已完成。',
    refunded_by_hand: '此付款已標記為人手退款。',
    open_octopus: '此退款仍可於付款亭領取。',
    open_soepay: 'SoePay 仍在處理此付款的退款。',
    none_octopus: '只有已過期而仍未退款的款項可標記為人手退款。',
    none_soepay: '只有已交由客戶服務處理而仍欠客戶款項的信用卡或 QR 付款可標記為人手退款。',
    soepay_in_progress: '此付款仍有 SoePay 指令在處理中，請於數分鐘後重新載入。',
    soepay_unchecked: 'SoePay 可能已退回此付款，請先按「再向 SoePay 查核」。',
  },
  providerActions: {
    check: '再向 SoePay 查核',
    retry: '再試一次',
    retryTitle: '再次發送至 SoePay？',
    retryBody: 'SoePay 於 %{checkedAt} 顯示收據 %{reference} 的「%{call}」（HK$%{amount}）未完成。再試一次會把指令再發送至 SoePay 一次。',
    retryConfirm: '再次發送',
    failed: '伺服器沒有回應，請於一分鐘後再試。',
    checked: {
      done: 'SoePay 顯示已完成，此付款已完成。',
      not_done_retry: 'SoePay 顯示未完成，您可按「再試一次」。',
      not_done: 'SoePay 顯示尚未完成，系統會自動再次發送。',
      unclear: 'SoePay 的回覆仍未能確定，請稍後再查核。',
      conflict: 'SoePay 的紀錄與我們的不符，請於 MARS 查看此付款。',
      none: 'SoePay 沒有回應，或指令仍在處理中，請於一分鐘後再查核。',
    },
    retried: {
      completed: 'SoePay 已完成。',
      failed: 'SoePay 再次拒絕，此付款仍交由客戶服務處理。',
      unknown: 'SoePay 沒有回應，系統會於數分鐘內自動再查核。',
      retry_scheduled: 'SoePay 暫時拒絕，系統會自動再次發送。',
      not_claimed: '另一程序正在處理，請於一分鐘後重新載入。',
    },
    refusals: {
      no_soepay_instruction: '此付款沒有可查核的 SoePay 指令。',
      nothing_to_check: '沒有需要查核的項目：SoePay 指令正等候執行或已完成。',
      refunded_by_hand: '此付款已標記為人手退款，不會再發送至 SoePay。',
      not_proven_undone: '只有 SoePay 顯示未完成的指令可再試一次，請先按「再向 SoePay 查核」。',
      state_changed: '此付款已有變更，請重新載入再查看。',
    },
  },
  actions: { export: '匯出 CSV' },
  messages: {
    exportFailed: '匯出失敗',
    noBreakdown: '此充電沒有費用明細',
    breakdownUnreconciled: '費用明細未能對賬：%{error}',
    noAttempts: '此付款沒有退款指令',
  },
  errors: {
    KIOSK_REFUND_NOT_MARKABLE: '此付款現時不能標記為人手退款',
    KIOSK_DOUBLE_REFUND_NOT_OPEN: 'This payment is not listed as refunded twice now',
    KIOSK_PROVIDER_ACTION_REFUSED: '此付款現時不能查核或再試',
    KIOSK_TRANSACTION_NOT_FOUND: '找不到付款亭交易',
  },
  tabs: { all: 'All payments', needsAction: 'Needs action' },
  needsAction: {
    groups: { owed: 'Refunds owed', payment_problem: 'Payment problems', refunded_twice: 'Refunded twice', waiting: 'Waiting for the customer' },
    hints: {
      owed: 'The customer did not collect the refund at the kiosk. Refund by hand, then mark it.',
      payment_problem: 'A card or QR payment call did not finish. Open it to check with SoePay or try again.',
      refunded_twice: 'The customer got this refund twice. Recover one, then mark it handled.',
      waiting: 'For information: the customer can still tap the card at the kiosk.',
    },
    amountLabels: { owed: 'Owed', payment_problem: 'Refund', refunded_twice: 'To recover', waiting: 'Refund' },
    owedFor: 'Owed for %{duration}',
    problemFor: 'Problem for %{duration}',
    twiceAgo: 'Paid twice %{duration} ago',
    timeLeft: '%{duration} left to collect',
    movesSoon: 'Moves to Refunds owed at the next hourly check',
    empty: 'Nothing here',
    open: 'Open',
    showMore: 'Show more',
    loadFailed: 'Could not load this list',
    duration: { minutes: '%{n} min', hours: '%{n} h', days: '%{d} d %{h} h' },
  },
  doubleRefund: {
    button: 'Mark handled',
    title: 'Mark the double refund handled',
    body: 'Record what was done about receipt %{reference}: the customer received the refund of HK$%{amount} twice. Any open alert for it is marked handled with the same note.',
    note: 'Note',
    noteHelper: 'What was done, for example "Recovered HK$110.30 by FPS on 2026-10-09"',
    confirm: 'Mark handled',
    done: 'Marked handled',
    failed: 'Could not mark it handled',
    notOpen: 'This payment is no longer listed as refunded twice.',
    notHandled: 'Not handled yet',
    handledLine: '%{at} by %{by}: %{note}',
  },
};
export const kioskTransactions = kioskTransactionsResource;
